<template>
  <div>
    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

    <v-toolbar flat class="primary">
      <h1 class="headline white--text">SEARCH DEVICES</h1>
    </v-toolbar>
    <v-card flat>
      <v-card-text>
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-toolbar flat color="white">
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchDevices"
                    append-icon="search"
                    label="Search Devices"
                    single-line
                    hide-details
                    max-width="50px"
                    class="pa-3"
                    clearable
                  ></v-text-field>
            </v-toolbar>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-data-table
        :headers="deviceSearchHeaders"
        :pagination.sync="pagination"
        :items="devices"
        :search="searchDevices"
        :loading="isloading"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-btn flat color="primary" @click="selectedDevice=props.item">
              <v-icon>add_circle_outline</v-icon>
            </v-btn>
          </td>
          <td class="text-xs-center" v-if="props.item.locationId!==null">{{props.item.location.locationDescription}}</td>
          <td class="text-xs-center" v-else-if="props.item.locationNetworkId!==null">{{props.item.locationNetwork.name}}</td>
          <td class="text-xs-center" v-else-if="props.item.locationNodeId!==null">{{props.item.locationNode.name}}</td>
          <td class="text-xs-center" v-else></td>

          <td class="text-xs-center" v-if="props.item.deviceMakeModel!==null">{{props.item.deviceMakeModel.deviceType.name}}</td>
          <td class="text-xs-center" v-else></td>
          <td class="text-xs-center" v-if="props.item.deviceMakeModel!==null">{{props.item.deviceMakeModel.deviceMake.name}}</td>
          <td class="text-xs-center" v-else></td>
          <td class="text-xs-center" v-if="props.item.deviceMakeModel!==null">{{props.item.deviceMakeModel.name}}</td>
          <td class="text-xs-center" v-else></td>
          <td class="text-xs-center">{{props.item.systemName}}</td>
          <td class="text-xs-center">{{props.item.serialNumber}}</td>
          <td class="text-xs-center">{{props.item.ponMac}}</td>
          <td class="text-xs-center">{{props.item.macAddress}}</td>
          <td class="text-xs-center">{{props.item.ponNumerical}}</td>
          <td class="text-xs-center">{{props.item.productNumber}}</td>
          <td class="text-xs-center" v-if="props.item.upstreamDeviceId!==null&& typeof(props.item.upstreamDevice) != 'undefined'">{{props.item.upstreamDevice.name}}</td>
        <td class="text-xs-center" v-else></td>
          <td class="text-xs-center">{{props.item.ponAddress}}</td>
          <td class="text-xs-center">{{props.item.ponId}}</td>
          <td class="text-xs-center">{{props.item.frame}}</td>
          <td class="text-xs-center">{{props.item.slot}}</td>
          <td class="text-xs-center">{{props.item.port}}</td>
          <td class="text-xs-center">{{props.item.note}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ recordCalculator(props.pageStart) }} - {{ recordCalculator(props.pageStop )}} of {{ devices.length }} {{pageCount(totalitems, props.pageStart, props.pageStop )}}</template>
      </v-data-table>
      <template>
        <div>
          <v-btn flat @click="$emit('deviceSearchCancelled')">Cancel</v-btn>
        </div>
      </template>
      <!-- <div class="text-xs-center pt-2">
      <v-btn flat  v-show="page>1" @click="pager(-1)"><v-icon>keyboard_arrow_left </v-icon> Previous</v-btn>
      <v-btn flat disabled >{{page}}</v-btn>
      <v-btn flat v-show="page<pages" @click="pager(1)">Next<v-icon>keyboard_arrow_right </v-icon> </v-btn>
      </div>-->
    </v-card>
  </div>
</template>
<script>
import Api from "@/services/Api";

export default {
  props: [
    "devicesearchmodal",
    "customerid",
    "devices",
    "totalitems",
    "isloading"
  ],
  data() {
    return {
      isloading:false,
      devices:[],
      pagination: {
        totalItems: this.totalitems
      },
      page: "",
      pages: "",
      limit: "",
      locationNetworkId: "",
      networkLocationArray: [],
      selectedDevice: "",
      searchDevices: "",
      deviceSearchHeaders: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Type",
          align: "center",
          value: "deviceMakeModel.deviceType.name"
        },
        {
          text: "Make",
          align: "center",
          value: "deviceMakeModel.deviceMake.name"
        },
        {
          text: "Model",
          align: "center",
          value: "deviceMakeModel.name"
        },
        {
          text: "System Name",
          align: "center",
          value: "serialNumber"
        },
        {
          text: "Serial Number",
          align: "center",
          value: "serialNumber"
        },
        {
          text: "PON MAC",
          align: "center",
          value: "ponMac"
        },
        {
          text: "MAC Address",
          align: "center",
          value: "macAddress"
        },
        {
          text: "PON Numerical",
          align: "center",
          value: "ponNumerical"
        },
        {
          text: "Product Number",
          align: "center",
          value: "productNumber"
        },
        {
          text: "Upstream Device",
          align: "center",
          value: "upstreamDevice.name"
        },
        {
          text: "PON Address",
          align: "center",
          value: "ponAddress"
        },
        {
          text: "PON ID",
          align: "center",
          value: "ponId"
        },
        {
          text: "Frame",
          align: "center",
          value: "frame"
        },
        {
          text: "Slot",
          align: "center",
          value: "slot"
        },
        {
          text: "Port",
          align: "center",
          value: "slot"
        },
        {
          text: "Note",
          align: "center",
          value: "note"
        }

      ]
    };
  },
  watch: {
    "$route.query.page": {
      immediate: true,
      handler(value) {
        this.page = value;
      }
    },
    selectedDevice(value) {
      const route = {
        name: this.$route.name
      };
      if(!this.$route.query.searchLocation){
      route.query = { selectedLocation: "", selectedDevice: value.id };}
      else {
        route.query = { selectedLocation: this.$route.query.selectedLocation, selectedDevice: value.id };}
      
      this.$router.push(route);
      this.$emit("deviceSearchCancelled");
    },
    "$route.query.limit": {
      immediate: true,
      handler(value) {
        this.limit = value;
      }
    },
    searchDevices(value) {
      const route = {
        name: this.$route.name
      };
      if (this.searchDevices !== "") {
         
          route.query = {
            selectedLocation: this.$route.query.selectedLocation,
            searchDevices: this.searchDevices
        }
      }
      this.$router.push(route);
    },
    // "$route.query": {
    //   immediate: true,
    //   handler(value) {
    //     this.isloading=true
    //     this.devices = [];
    //     this.search = value;
    //     if (this.$route.query.searchDevices) {
    //         Api()
    //         .get('/devices',{
    //             params: {
    //                 search: this.search.searchDevices
    //             }
    //         }).then(response=>{
    //           this.isloading=false
    //             this.devices=response.data
    //         })
    //   } else {
    //     Api()
    //         .get('/devices').then(response=>{
    //           this.isloading=false
    //             this.devices=response.data
    //         })
    //   }
    // }},

    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    recordCalculator(value) {
      return value + Math.ceil(this.pagination.rowsPerPage * (this.page - 1));
    },
    pager(value) {
      this.page = parseInt(this.page) + parseInt(value);
      this.pagination.page = this.page;
    },
    pageCount(totalItems, start, end) {
      if (typeof this.page === "undefined") {
        this.page = 1;
      }
      this.pages = Math.ceil(this.totalitems / this.pagination.rowsPerPage);
      this.limit = this.pagination.rowsPerPage;
      if (start - end === 0 && totalItems > 1) {
        this.limit = this.pagination.rowsPerPage;
      } else {
        this.limit = this.pagination.rowsPerPage;
      }
    }
  }
}
</script>

